import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from 'antd';
import { connect } from 'dva';
import { Logout, BindWx, PasswordReset, PersonalInfo } from '@components';
import { HomeOutlined } from '@ant-design/icons';
import { cdnImageDomain } from '@untils/config';
import './index.less';

const { Header } = Layout;
const appName = process.env.APP_NAME;
const logoUrl = `//${cdnImageDomain}/logo/${appName}.png`;

const LayoutHeader = ({ collapsed, dispatch }) => {
  const switchMenu = () => {
    dispatch({
      type: 'menu/switchMenu',
      payload: {
        collapsed: !collapsed,
      },
    });
  };

  const mode = process.env.NODE_ENV;
  let url = '/old/system/284#http://ht.dev.yijiahaohuo.com/backend/web/?inIframe=1';

  if (mode === 'production') {
    url = '/old/system/284#http://ht.yijiahaohuo.com/backend/web/?inIframe=1';
  }

  return (
    <Header className="top-header">
      <div className="left" onClick={switchMenu}>
        <img src={logoUrl} className="logo-icon" />
        <span className="header-title">后台管理系统</span>
      </div>
      <div className="right">
        <Link to={url} style={{ color: '#fff' }}>
          <HomeOutlined />
          首页
        </Link>

        <PersonalInfo />
        <BindWx />
        <span className="ml-12"></span>
        <PasswordReset />
        <Logout />
      </div>
    </Header>
  );
};

const mapStateToProps = state => {
  const { menu = {} } = state;
  const { collapsed = false } = menu;

  return { collapsed };
};

export default connect(mapStateToProps)(LayoutHeader);
